<template>
  <DrawerVue :refreshDisplay="refreshDisplay">
    <v-container fluid class="mt-4">
      <v-row class="mb-4" align="center">
        <v-col cols="auto">
          <h2 v-if="productData">
            {{ $t("basics.edit", { type: $t("basics.product") }) }}
          </h2>
          <h2 v-else>
            {{ $t("basics.new", { type: $t("basics.product") }) }}
          </h2>
        </v-col>

        <v-spacer />

        <v-col cols="auto" v-if="productData && $checkFunctionPermission(['product_delete_detail'])">
          <v-tooltip :text="$t('basics.delete')">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" @click="showDeleteProuct()" class="icon-transparency hoverable">
                mdi-trash-can
              </v-icon>
            </template>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-form ref="productEditForm">
        <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" flat :rules="[requiredRule, max256]" v-model="name"
              :label="$t('basics.name') + '*'" :readonly="readonly"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-select :disabled="productData != undefined" variant="outlined" flat :items="availTypes"
              :rules="[requiredRule]" v-model="type" :label="$t('basics.type') + '*'"
              @update:model-value="selectPresets" returnObject item-title="name" item-value="name"
              :readonly="readonly"></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-textarea variant="outlined" flat :rules="[max5000]" v-model="description"
              :label="$t('basics.description')" :readonly="readonly"></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col :cols="isPsycotherapy ? 12 : 6">
            <v-text-field variant="outlined" flat type="number" step="0.01" :rules="[requiredRule]" v-model="price"
              :label="$t('basics.price') + ' ' + $t('basics.net') + '*'" :readonly="readonly"
              @blur="validatePrice(); calcBrut()"></v-text-field>
          </v-col>
          <v-col cols="6" v-if="!isPsycotherapy">
            <v-text-field variant="outlined" flat type="number" step="0.01" :rules="[requiredRule]"
              v-model="priceBrutto" :label="$t('basics.price') + ' ' + $t('basics.brut') + '*'" :readonly="readonly"
              @blur="validatePrice(); calcNet()"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-select variant="outlined" flat :items="availStatuses" :rules="[requiredRule]" v-model="status"
              :label="$t('basics.status') + '*'" returnObject
              :item-title="(item) => $t('constants.product_status_' + item.name)" item-value="name"
              :readonly="readonly"></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" flat type="number" :rules="[requiredRule]" v-model="duration"
              :label="$t('basics.duration') + '*'" :readonly="readonly"></v-text-field>
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col cols="12">
            <v-select variant="outlined" flat :items="availPaymentMethods" :rules="[requiredRule]"
              v-model="paymentMethod" returnObject :item-title="(item) => $t('constants.payment_method_' + item.name)"
              item-value="name" :label="$t('basics.paymentMethod') + '*'" :readonly="readonly"></v-select>
          </v-col>
        </v-row> -->


        <v-row>
          <v-col cols="12">
            <v-checkbox class="hideDetails" :label="$t('messages.defaultAppointmentProduct')" :readonly="readonly"
              v-model="defaultAppointmentProduct">
            </v-checkbox>
          </v-col>
        </v-row>


        <v-row>
          <v-col cols="12">
            <v-checkbox class="hideDetails" :label="$t('messages.isPsycotherapy')" :readonly="readonly"
              v-model="isPsycotherapy">
            </v-checkbox>
          </v-col>
        </v-row>


        <v-row v-if="!readonly">
          <v-col cols="12">
            <v-btn large block flat class="primaryButton" @click="confirm()" :loading="loading" ref="confirmButton"
              style="width: 100%">
              <span>{{ $t("basics.confirm") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </DrawerVue>
</template>

<script>
export default {
  name: "productEditDrawer",
  props: ["productData", "refreshDisplay", "readonly"],
  emits: ["close", "delete"],

  data() {
    return {
      name: undefined,
      description: undefined,
      price: undefined,
      priceBrutto: undefined,
      status: undefined,
      duration: undefined,
      paymentMethod: undefined,
      type: undefined,

      loading: false,

      isPsycotherapy: false,
      defaultAppointmentProduct: false,

      availStatuses: [],
      availPaymentMethods: [],
      availTypes: [],

      requiredRule: (value) =>
        value !== null && value !== undefined && value !== '' ||
        this.$i18n.t("messages.required"),
      max256: (value) =>
        !value || value.length <= 256 || this.$i18n.t("messages.tooLong", { count: 256 }),
      max5: (value) =>
        !value || value.length <= 5 || this.$i18n.t("messages.tooLong", { count: 5 }),
      max5000: (value) =>
        !value ||
        value.length <= 5000 ||
        this.$i18n.t("messages.tooLong", { count: 5000 }),
    };
  },

  components: {
  },

  watch: {
    refreshDisplay() {
      this.fetchStatuses().then(() => {
        this.fetchPaymentMethods().then(() => {
          this.fetchTypes().then(() => {
            this.setValues();
          })
        })
      })
    },
  },

  methods: {
    validatePrice(val) {
      if (this.price > 99999) {
        this.price = 99999
      }
    },
    calcNet() {
      if (!this.priceBrutto) {
        this.price = 0
      }
      else {
        this.price = +(this.priceBrutto / 1.19).toFixed(2);
      }
    },
    calcBrut() {
      if (!this.price) {
        this.priceBrutto = 0
      }
      else {
        this.priceBrutto = +(this.price * 1.19).toFixed(2);
      }
    },
    showDeleteProuct() {
      this.$emit("delete")
    },
    selectPresets(type) {
      if (type) {
        if (type.default_price !== undefined) {
          this.price = type.default_price
        }

        if (type.default_payment_method !== undefined) {
          this.paymentMethod = this.availPaymentMethods[type.default_payment_method]
        }

        if (type.default_duration !== undefined) {
          this.duration = type.default_duration
        }

        this.isPsycotherapy = type.is_psycotherapy

        this.calcBrut()
      }
    },
    async fetchStatuses() {
      return new Promise((resolve, reject) => {
        this.axios.get(this.axios.defaults.baseURL + "media/productstatuses/")
          .then((resp) => {
            this.availStatuses = resp.data

            resolve()
          })
          .catch((e) => {
            reject()
            console.log(e);
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          });
      })
    },
    async fetchPaymentMethods() {
      return new Promise((resolve, reject) => {
        this.axios.get(this.axios.defaults.baseURL + "media/paymentmethods/")
          .then((resp) => {
            this.availPaymentMethods = resp.data

            resolve()
          })
          .catch((e) => {
            reject()
            console.log(e);
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          });
      })
    },
    async fetchTypes() {
      return new Promise((resolve, reject) => {
        this.axios.get(this.axios.defaults.baseURL + "media/producttypes/?size=10000")
          .then((resp) => {
            this.availTypes = resp.data.results

            resolve()
          })
          .catch((e) => {
            reject()
            console.log(e);
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          });
      })
    },
    async confirm() {
      const { valid } = await this.$refs.productEditForm.validate();

      if (valid) {
        this.loading = true

        let formData = {
          name: this.name,
          description: this.description,
          price: this.price !== undefined && this.price !== null
            ? parseFloat(this.price)
            : null,

          duration: this.duration !== undefined && this.duration !== null
            ? parseInt(this.duration)
            : null,
          duration: this.duration ? parseInt(this.duration) : null,
          type: this.type.id,
          is_default: this.defaultAppointmentProduct,
          is_psycotherapy: this.isPsycotherapy
        };

        if (this.status !== undefined) {
          formData.status = this.status.key
        }
        if (this.paymentMethod !== undefined) {
          formData.payment_method = this.paymentMethod.key
        }

        if (this.productData) {
          formData.id = this.productData.id;
          this.patchData(formData);
        } else {
          this.postData(formData);
        }
      }
    },
    postData(formData) {
      this.axios
        .post(this.axios.defaults.baseURL + "media/products/post/", formData)
        .then((resp) => {
          this.$emit("close", 1);

          this.loading = false
        })
        .catch((e) => {
          console.log(e);
          this.loading = false
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },

    patchData(formData) {
      this.axios
        .patch(
          this.axios.defaults.baseURL + "media/products/patch/" + formData.id,
          formData
        )
        .then((resp) => {
          this.$emit("close", 1);
          this.loading = false
        })
        .catch((e) => {
          console.log(e);
          this.loading = false
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    setValues() {
      this.loading = false
      if (this.productData) {
        this.name = this.productData.name;
        this.description = this.productData.description;
        this.price = this.productData.price;
        this.priceBrutto = +(this.productData.price * 1.19).toFixed(2);
        this.duration = this.productData.duration;
        this.type = this.productData.type


        this.isPsycotherapy = this.productData.is_psycotherapy
        this.defaultAppointmentProduct = this.productData.is_default

        if (this.productData.status !== undefined) {
          for (let i = 0; i < this.availStatuses.length; i++) {
            if (this.productData.status == this.availStatuses[i].key) {
              this.status = this.availStatuses[i]
            }
          }
        }
        else {
          this.status = undefined;
        }

        if (this.productData.payment_method !== undefined) {
          for (let i = 0; i < this.availPaymentMethods.length; i++) {
            if (this.productData.payment_method == this.availPaymentMethods[i].key) {
              this.paymentMethod = this.availPaymentMethods[i]
            }
          }
        }
        else {
          this.paymentMethod = undefined;
        }
      } else {
        this.name = undefined;
        this.description = undefined;
        this.price = undefined;
        this.priceBrutto = undefined;
        this.duration = undefined;
        this.type = undefined

        this.status = undefined;
        this.paymentMethod = undefined;

        this.isPsycotherapy = false
        this.defaultAppointmentProduct = false

      }
    },
  },

  mounted() { },
};
</script>
